import { API } from "aws-amplify";

const show = async (params) => {
  let myInit = { // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: params, // OPTIONAL
    headers: {}
  };
  let items = await API.get("InasakuAPI", "/inasaku/brands", myInit);
  return items;
};

const insert = async (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };

  let res = await API.post("InasakuAPI", "/inasaku/brands", myInit);

  return res;
};

const update = async (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params, // replace this with attributes you need
    },
    headers: {} // OPTIONAL
  };
  let res = await API.put("InasakuAPI", `/inasaku/brands`, myInit);

  return res;
};

const del = async (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    }, // replace this with attributes you need
    headers: {} // OPTIONAL
  };

  let res = await API.del("InasakuAPI", `/inasaku/brands`, myInit);

  return res;
};
const init = async (params) => {
  let myInit = { // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: params, // OPTIONAL
    headers: {}
  };
  let items = await API.get("InasakuAPI", "/inasaku/create-brand-master-data", myInit);
  return items;
};

const updateOrder = async (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params, // replace this with attributes you need
    },
    headers: {} // OPTIONAL
  };

  let res = await API.post("InasakuAPI", `/inasaku/brands/order`, myInit);

  return res;
};

export default {
  show,
  insert,
  update,
  del,
  init,
  updateOrder,
};
